import { Box, Container, Flex, Text } from "@chakra-ui/react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function Back({ title, reload = { value: false } }) {
  const navigate = useNavigate();

  return (
    <Container
      backgroundColor="white"
      padding="10px 12px"
      borderBottom="1px solid #e7e7e7"
      position="relative"
      maxWidth="768px"
    >
      <Box>
        <Flex alignItems="center">
          {reload.value ? (
            <a
              href={reload.dest}
              style={{ display: "flex", alignItems: "center" }}
            >
              <FaArrowLeft style={{ position: "absolute" }} cursor="pointer" />
            </a>
          ) : (
            <>
              <FaArrowLeft
                style={{ position: "absolute" }}
                cursor="pointer"
                onClick={() => navigate(-1)}
              />
            </>
          )}
          <Text w="100%" textAlign="center">
            {title}
          </Text>
        </Flex>
      </Box>
    </Container>
  );
}
